import { f as r } from "../internals/function-apply.js";
import { f as n } from "../internals/function-call.js";
import { f as t } from "../internals/function-uncurry-this.js";
import { f as a } from "../internals/fix-regexp-well-known-symbol-logic.js";
import { f as i } from "../internals/fails.js";
import { a as e } from "../internals/an-object.js";
import { i as s } from "../internals/is-callable.js";
import { i as o } from "../internals/is-null-or-undefined.js";
import { t as l } from "../internals/to-integer-or-infinity.js";
import { t as f } from "../internals/to-length.js";
import { t as m } from "../internals/to-string.js";
import { r as p } from "../internals/require-object-coercible.js";
import { a as c } from "../internals/advance-string-index.js";
import { g as u } from "../internals/get-method.js";
import { g as v } from "../internals/get-substitution.js";
import { r as g } from "../internals/regexp-exec-abstract.js";
import { w as j } from "../internals/well-known-symbol.js";
var d = j("replace"),
  h = Math.max,
  x = Math.min,
  b = t([].concat),
  $ = t([].push),
  y = t("".indexOf),
  w = t("".slice),
  k = "$0" === "a".replace(/./, "$0"),
  I = !!/./[d] && "" === /./[d]("a", "$0");
a("replace", function (t, a, i) {
  var j = I ? "$" : "$0";
  return [function (r, t) {
    var i = p(this),
      e = o(r) ? void 0 : u(r, d);
    return e ? n(e, r, i, t) : n(a, m(i), r, t);
  }, function (n, t) {
    var o = e(this),
      p = m(n);
    if ("string" == typeof t && -1 === y(t, j) && -1 === y(t, "$<")) {
      var u = i(a, o, p, t);
      if (u.done) return u.value;
    }
    var d = s(t);
    d || (t = m(t));
    var k = o.global;
    if (k) {
      var I = o.unicode;
      o.lastIndex = 0;
    }
    for (var M = [];;) {
      var q = g(o, p);
      if (null === q || ($(M, q), !k)) break;
      "" === m(q[0]) && (o.lastIndex = c(p, f(o.lastIndex), I));
    }
    for (var O = "", S = 0, z = 0; z < M.length; z++) {
      for (var A, B = m((q = M[z])[0]), C = h(x(l(q.index), p.length), 0), D = [], E = 1; E < q.length; E++) $(D, void 0 === (A = q[E]) ? A : String(A));
      var F = q.groups;
      if (d) {
        var G = b([B], D, C, p);
        void 0 !== F && $(G, F);
        var H = m(r(t, void 0, G));
      } else H = v(B, p, C, D, F, t);
      C >= S && (O += w(p, S, C) + H, S = C + B.length);
    }
    return O + w(p, S);
  }];
}, !!i(function () {
  var r = /./;
  return r.exec = function () {
    var r = [];
    return r.groups = {
      a: "7"
    }, r;
  }, "7" !== "".replace(r, "$<a>");
}) || !k || I);